import { AppRoutes } from "./Routes";
import { GlobalStyle } from "./styles/global";
import { GlobalHint } from "./styles/globalHint";

export function App() {
  return (
    <>
      <GlobalStyle />
      <GlobalHint />
      <AppRoutes />
    </>
  );
}
export default App;
